import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './viewcartscreen.css';
import { toast } from 'react-toastify';
import { Products } from '../../appojo/models/Products';

import {
    requestApi, RequestModel, ResponseModel,
    EndPointPaths, printConsole, AssetConstants,
    RouteConstants, SessionKeys, clientConfig,
    i18n, strings, checkLoginData
} from '../../utils/CommonImports';
import { CartRequest } from '../../appojo/requestmodel/CartRequest';
import { Customers } from '../../appojo/models/Customers';
import { ProductsInCart } from '../../appojo/models/ProductsInCart';


const ViewCartScreen = (props: any) => {
    const navigate = useNavigate();
    const [stateValue, setStateValue] = useState({
        languageName: '',
        users: null,
        previousMenu: RouteConstants.DashBoard,
    });
    const [showLoader, setShowLoader] = useState(false);
    const [cartQuantity, setCartQuantity] = useState(props.cartQuantity != null ? props.cartQuantity : 0);
    const [isConnected, setIsConnected] = useState(true);
    const [initialState, setInitialState] = useState(true);
    const [dummyData, setDummyData] = useState(true);
    // const [similarProducts, setSimilarProducts] = useState(new Products());
    const [similarProducts, setSimilarProducts] = useState<Products[]>([]);
    // const [cartList, setCartList] = useState([]);
    const [cartList, setCartList] = useState<ProductsInCart[]>([])
    const [cartSummary, setCartSummary] = useState(null);

    useEffect(() => {
        getSessionValues()
            .then((users) => {
                if (checkLoginData(users)) {
                    getAllCartItems();
                } else {
                    setInitialState(false);
                }
                setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                }, 0)
            });

        return () => {

        }
    }, [props]);


    const getSessionValues = async () => {
        const users = JSON.parse(sessionStorage.getItem(SessionKeys.loginObj));
        const previousMenu = sessionStorage.getItem(SessionKeys.previousMenu);
        let language = sessionStorage.getItem(SessionKeys.languageName);
        if (language === null) {
            language = clientConfig.defaultLanguage;
        }
        i18n.changeLanguage(language);
        stateValue.languageName = language;
        stateValue.previousMenu = previousMenu;
        stateValue.users = users;
        setStateValue(stateValue);
        return users;
    }

    const getAllCartItems = async () => {
        try {
            setShowLoader(true);
            const request = new RequestModel();
            const customer = new Customers();
            customer.id = stateValue.users.id;
            request.reqObject = customer;
            const responseResult = await requestApi(request, EndPointPaths.getallcartitemsbycustomerid, isConnected);
            if (responseResult.status === 0) {
                const responsemodel: ResponseModel = responseResult.data;
                if (responsemodel.statusCode === 0) {
                    printConsole("cart le: " + responsemodel.respList.length)
                    setCartList(responsemodel.respList);
                    setCartSummary(responsemodel.respObject);
                } else if (responsemodel.statusCode === 2 || responsemodel.statusCode === 1) {
                    setCartList([]);
                    setCartSummary(null);
                } else {
                    setCartList([]);
                    setCartSummary(null);
                }
            } else {
                setCartList([]);
                setCartSummary(null);
            }
        } catch (err) {
        } finally {
            setShowLoader(false);
            setInitialState(false);
        };
    }

    const addtoCart = async (cartItem: ProductsInCart) => {
        try {
            if (checkLoginData(stateValue.users)) {
                if (cartItem.quantity < 5) {
                    setShowLoader(true);
                    const request = new RequestModel();
                    const cartRequest = new CartRequest();
                    cartRequest.userId = stateValue.users.id;
                    cartRequest.productId = cartItem.productObj.id;
                    cartRequest.quantity = 1;
                    request.userId = '809957651';
                    request.reqObject = cartRequest;
                    const responseResult = await requestApi(request, EndPointPaths.addtocart, isConnected);
                    if (responseResult.status === 0) {
                        const responsemodel: ResponseModel = responseResult.data;
                        if (responsemodel.statusCode === 0) {
                            setCartList(responsemodel.respList);
                            setCartSummary(responsemodel.respObject);
                        } else if (responsemodel.statusCode === 1 || responsemodel.statusCode === 2 || responsemodel.statusCode === 11) {
                            toast(strings(responsemodel.message));
                        } else {
                            toast(strings('plsetry'));
                        }
                    } else if (responseResult.status === 1) {
                        printConsole("API dash Error 1: " + responseResult.data)
                        toast(strings('plsetry'));
                    } else if (responseResult.status === 2) {
                        printConsole("API dash Error 2: " + responseResult.data)
                        toast(strings('plsetry'));
                    } else {
                        printConsole("API dash Error 3: " + responseResult.data)
                        toast(strings('plsetry'));
                    }
                }
                else {
                    toast(strings('maximumfivequantitymandatory'))
                }
            } else {
                saveStorage(RouteConstants.UserCartScreen, SessionKeys.previousMenu, 'string');
                document.getElementById("loginForm").style.display = "block";
            }
        } catch (err) {
            printConsole("Try Error addtocart: " + err);
            toast(strings('plsetry'));
        } finally {
            setShowLoader(false);
        }
    }
    const removeCart = async (productObj: Products) => {
        try {
            if (checkLoginData(stateValue.users)) {
                setShowLoader(true);
                const request = new RequestModel();
                const cartRequest = new CartRequest();
                cartRequest.userId = stateValue.users.id;
                cartRequest.productId = productObj.id;
                cartRequest.quantity = 1;
                request.userId = '809957651';
                request.reqObject = cartRequest;
                const responseResult = await requestApi(request, EndPointPaths.removecart, isConnected);
                if (responseResult.status === 0) {
                    const responsemodel: ResponseModel = responseResult.data;
                    if (responsemodel.statusCode == 0) {
                        setCartList(responsemodel.respList);
                        setCartSummary(responsemodel.respObject);
                    } else if (responsemodel.statusCode === 1) {
                        //remove all
                        setCartList([]);
                        setCartSummary(null);
                    } else if (responsemodel.statusCode === 2) {
                        //remove all
                        setCartList([]);
                        setCartSummary(null);
                    } else if (responsemodel.statusCode === 3) {
                        //remove all
                        setCartList([]);
                        setCartSummary(null);
                    } else if (responsemodel.statusCode === 11) {
                        toast(strings(responsemodel.message));
                    } else {
                        toast(strings('plsetry'));
                    }
                } else if (responseResult.status == 1) {
                    printConsole("API dash Error 1: " + responseResult.data)
                    toast(strings('plsetry'));
                } else if (responseResult.status == 2) {
                    printConsole("API dash Error 2: " + responseResult.data)
                    toast(strings('plsetry'));
                } else {
                    printConsole("API dash Error 3: " + responseResult.data)
                    toast(strings('plsetry'));
                }
            } else {
                saveStorage(RouteConstants.UserCartScreen, SessionKeys.previousMenu, 'string');
                document.getElementById("loginForm").style.display = "block";
            }
        } catch (err) {
            printConsole("Try Error removecart: " + err);
            toast(strings('plsetry'));
        } finally {
            setShowLoader(false);
        }
    }
    const saveStorage = async (value: any, key: any, type: any) => {
        if (type === "object") {
            sessionStorage.setItem(key, JSON.stringify(value));
        } else if (type === "remove") {
            sessionStorage.removeItem(key);
        } else {
            sessionStorage.setItem(key, value)
        }
    }
    const removeCartItem = async (productObj: Products) => {
        try {
            if (checkLoginData(stateValue.users)) {
                setShowLoader(true);
                const request = new RequestModel();
                const cartRequest = new CartRequest();
                cartRequest.userId = stateValue.users.id;
                cartRequest.productId = productObj.id;
                cartRequest.quantity = 1;
                request.userId = '809957651';
                request.reqObject = cartRequest;
                const responseResult = await requestApi(request, EndPointPaths.removeproductcart, isConnected);
                if (responseResult.status === 0) {
                    const responsemodel: ResponseModel = responseResult.data;
                    if (responsemodel.statusCode === 0) {
                        //check for one then remove all
                        // ToastMessage.showSuccess(strings(responsemodel.message));
                        setCartList(responsemodel.respList);
                        setCartSummary(responsemodel.respObject);
                    } else if (responsemodel.statusCode === 1) {
                        //remova all list and summary
                        setCartList([]);
                        setCartSummary(null);
                    } else if (responsemodel.statusCode === 2) {
                        //remova all list and summary
                        setCartList([]);
                        setCartSummary(null);
                    } else if (responsemodel.statusCode === 5) {
                        //remova all list and summary
                        setCartList([]);
                        setCartSummary(null);
                    } else if (responsemodel.statusCode === 6) {
                        //check inputs
                    } else if (responsemodel.statusCode === 11) {
                        toast(strings(responsemodel.message));
                    } else {
                        toast(strings('plsetry'));
                    }
                } else if (responseResult.status === 1) {
                    printConsole("API dash Error 1: " + responseResult.data)
                    toast(strings('plsetry'));
                } else if (responseResult.status === 2) {
                    printConsole("API dash Error 2: " + responseResult.data)
                    toast(strings('plsetry'));
                } else {
                    printConsole("API dash Error 3: " + responseResult.data)
                    toast(strings('plsetry'));
                }
            } else {
                document.getElementById("loginForm").style.display = "block";
            }
        } catch (err) {
            printConsole("Try Error remove cart: " + err);
            toast(strings('plsetry'));
        } finally {
            setShowLoader(false);
        }
    }
    const addToWishList = async (productObj) => {
        try {
            if (checkLoginData(stateValue.users)) {
                setShowLoader(true);
                const request = new RequestModel();
                const cartRequest = new CartRequest();
                cartRequest.userId = stateValue.users.id;
                cartRequest.productId = productObj.id;
                cartRequest.quantity = 1;
                request.userId = '809957651';
                request.reqObject = cartRequest;
                const responseResult = await requestApi(request, EndPointPaths.replacecartitemtowishlist, isConnected);
                if (responseResult.status === 0) {
                    const responsemodel: ResponseModel = responseResult.data;
                    if (responsemodel.statusCode === 0) {
                        // ToastMessage.showSuccess(strings(responsemodel.message));
                        setCartList(responsemodel.respList);
                        setCartSummary(responsemodel.respObject);
                    } else if (responsemodel.statusCode === 2) {
                        //remove all list and summaray
                    } else if (responsemodel.statusCode === 5) {
                        //remove all list and summaray
                    } else if (responsemodel.statusCode === 11) {
                        toast(strings(responsemodel.message));
                    } else {
                        toast(strings('plsetry'));
                    }
                } else if (responseResult.status === 1) {
                    printConsole("API dash Error 1: " + responseResult.data)
                    toast(strings('plsetry'));
                } else if (responseResult.status === 2) {
                    printConsole("API dash Error 2: " + responseResult.data)
                    toast(strings('plsetry'));
                } else {
                    printConsole("API dash Error 3: " + responseResult.data)
                    toast(strings('plsetry'));
                }
            } else {
                document.getElementById("loginForm").style.display = "block";
            }
        } catch (err) {
            printConsole("Try Error wishlist: " + err);
            toast(strings('plsetry'));
        } finally {
            setShowLoader(false);
        }

    }
    const calculatePercentage = (actualPrice: number, offerPrice: number) => {
        const differenceAmount = actualPrice - offerPrice;
        const percentage = differenceAmount / actualPrice * 100;
        return Math.round(percentage * Math.pow(10, 2)) / Math.pow(10, 2);;
    }
    return (
        < >

            <section className='mt-3'>
                <div className='container' >
                    <div className='fixed-bottom' style={{ backgroundColor: "transparent" }}>
                        <div className="fixed-bottom boxShadow" style={{ backgroundColor: 'white', position: 'fixed', bottom: '0', width: '100%', left: '0', }}>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <div style={{ width: '50%' }}>
                                    <button className='placeOrder1 '>
                                        <p>₹239</p>
                                    </button>
                                </div>
                                <div style={{ width: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <button className='placeOrder '>&nbsp;place Order</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='row'>

                        <div className='col-sm-8 pt-2 pb-2 mt-2' style={{ border: '1px solid #eee', boxShadow: 'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px' }}>
                            {cartList.map((item, index) => {
                                return (
                                    <div key={index} className='row pb-2 pt-2' style={{ borderBottom: '1px solid #ccc' }}>
                                        <div className='col-4 col-sm-2'>
                                            <div>
                                                <img className='cartImage' style={{ height: '110px', width: '100%', borderRadius: '4px' }}
                                                    onError={({ currentTarget }) => {
                                                        currentTarget.onerror = null;
                                                        currentTarget.src = AssetConstants.defaultimg;
                                                    }}
                                                    src={item.productObj.productThumbNailImage} />
                                                <div className='mt-2' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <span className='fa fa-minus' style={{ padding: '7px 9px', backgroundColor: '#eee', borderRadius: "50px" }} onClick={() => removeCart(item.productObj)}> </span>
                                                    <span style={{ border: '1px solid #ccc', padding: '2px 15px', marginLeft: '2px', marginRight: '2px' }}>{item.quantity}</span>
                                                    <span className='fa fa-plus' style={{ padding: '7px 9px', backgroundColor: '#eee', borderRadius: "50px" }} onClick={() => addtoCart(item)}></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-8 col-sm-10'>
                                            <div>
                                                <div>
                                                    <h6 style={{ color: '#212121', fontWeight: '400', fontSize: '16px' }}>{item.productObj.title}</h6>
                                                    <h6 style={{ color: '#878787', fontWeight: '400' }}>{item.productObj.brandObj.brandName}</h6>
                                                </div>
                                                <div>
                                                    <p style={{ fontSize: '28px', fontWeight: '500' }}>{clientConfig.currencySymbol}{item.productObj.offerPrice}
                                                        <span style={{ fontSize: '15px', textDecoration: 'line-through', color: '#aaa', fontWeight: '500' }}>{clientConfig.currencySymbol}{item.productObj.actualPrice},</span>
                                                        <span style={{ fontSize: '14px', color: '#388e3c', fontWeight: '500' }}>{calculatePercentage(item.productObj.actualPrice, item.productObj.offerPrice)}% off</span></p>
                                                </div>
                                                <div>
                                                    <h6 style={{ color: item.productObj.availableQuantity > 0 ? 'green' : '#ff6161', fontSize: '20px', fontWeight: '400' }}>{item.productObj.availableQuantity > 0 ? 'Available' : 'Out Of stock'} </h6>
                                                </div>
                                                <div>
                                                    <h6>View size chart</h6>
                                                </div>

                                            </div>
                                        </div>
                                        <div className='mt-4' style={{ display: 'flex' }}>
                                            <div style={{ width: '50%' }}>
                                                <button className='saveRemove fa fa-heart' onClick={() => { addToWishList(item.productObj) }}>&nbsp;Save for later</button>
                                            </div>
                                            <div style={{ width: '50%', marginLeft: "2px" }}>
                                                <a><button className='saveRemove fa fa-trash' onClick={() => { removeCartItem(item.productObj) }} >&nbsp;Remove</button></a>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                        {cartSummary != null && cartSummary.grandTotal != null ?
                            <div className='col-sm-4 mt-2 mb-2'>
                                <div style={{ boxShadow: 'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px', border: "1px solid #eee" }}>
                                    <div style={{ borderBottom: '1px solid #eee', padding: '2px 5px' }}>
                                        <h4 style={{ textAlign: 'center' }}>ORDER SUMMARY</h4>
                                    </div>
                                    <div className='mt-3' style={{ display: 'flex', padding: '2px 15px' }}>
                                        <div>
                                            <h6>Price ({cartList.length} items)</h6>
                                        </div>
                                        <div style={{ marginLeft: 'auto' }}>
                                            <h6>{clientConfig.currencySymbol}{cartSummary.actualAmount}</h6>
                                        </div>
                                    </div>
                                    <div className='mt-3' style={{ display: 'flex', padding: '2px 15px' }}>
                                        <div>
                                            <h6>Discount</h6>
                                        </div>
                                        <div style={{ marginLeft: 'auto' }}>
                                            <h6>− {clientConfig.currencySymbol}{cartSummary.discounts}</h6>
                                        </div>
                                    </div>
                                    <div className='mt-3 pb-2 mb-2' style={{ display: 'flex', padding: '2px 15px', borderBottom: '1px dashed #ccc' }}>
                                        <div>
                                            <h6>Delivery Charges</h6>
                                        </div>
                                        <div style={{ marginLeft: 'auto' }}>
                                            <h6>FREE</h6>
                                        </div>
                                    </div>
                                    <div className='mt-3 pb-2 mb-2' style={{ display: 'flex', padding: '2px 15px' }}>
                                        <div>
                                            <h6>Total Amount</h6>
                                        </div>
                                        <div style={{ marginLeft: 'auto' }}>
                                            <h6>{clientConfig.currencySymbol}{cartSummary.grandTotal}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : null}


                    </div>
                </div>
            </section>

        </>
    )
}
export default ViewCartScreen;